import { getWebhooks } from '../../api';
import { useProcessedList } from '../../hooks';
import { splitSnakeCase } from '../../utilities';
import type { WebhookItem, GetWebhooksFilters } from '../../api';

export type ItemType = WebhookItem & { event_type_enum: string };

export const useWebhooks = () => {
  return useProcessedList<ItemType, GetWebhooksFilters>(
    async params => {
      const result = await getWebhooks(
        params?.filters || {},
        { offset: 0, limit: 1_000 }
        // params?.pagination
      );

      return {
        content: result.map(item => ({
          ...item,
          event_type_enum: item.event_type,
          event_type: splitSnakeCase(item.event_type, { capitalize: true }),
        })),
      };
    },
    {
      withLocalSort: true,
      withQueryParams: true,
      withLocalPagination: true,
      // initialPageSize: 10,
      initialFilters: { campaignId: '', eventType: '' },
    }
  );
};
